import React from 'react';
import { Route, IndexRoute, IndexRedirect } from 'react-router';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';

import EnsureLoggedIn from 'containers/EnsureLoggedIn';
import EnsureAdmin from 'containers/EnsureAdmin';
import Home from 'containers/Home';

import AdminPanel from 'components/AdminPanel';
import Login from 'components/Login';
import Worker from 'components/Worker/Worker';
import Construction from 'components/Construction/Construction';
import Cost from 'components/Report/Cost';
import Payroll from 'components/Report/Payroll';
import Receipt from 'components/Report/Receipt';

import Setting from 'components/Setting/Setting';
import AdjustmentPanel from 'components/Setting/AdjustmentPanel';
import CompanyPanel from 'components/Setting/CompanyPanel';
import PaymentPanel from 'components/Setting/PaymentPanel';
import PositionPanel from 'components/Setting/PositionPanel';
import SessionPanel from 'components/Setting/SessionPanel';
import ChangePwdPanel from 'components/Setting/ChangePwdPanel';

import PageNotFound from 'components/PageNotFound';

const ROUTE_PREFIX = ""//"/~Craxh/workersystem";

export function getURL(path) {
  return ROUTE_PREFIX + path
}

export default (
  <Route path={ROUTE_PREFIX || '/'}>
    <Route component={EnsureLoggedIn}>
      <IndexRoute component={Home} />
      <Route path="ws-admin" component={EnsureAdmin}>
        <IndexRedirect to="worker" />
        <Route path="report">
          <Route path="cost/:cid" component={Cost} />
          <Route path="payroll/:uid/:year/:month" component={Payroll} />
          <Route path="receipt/:uid/:year/:month" component={Receipt} />
        </Route>
        <Route component={AdminPanel}>
          <Route path="worker" component={Worker} />
          <Route path="site" component={Construction} />
          <Route path="setting">
            <IndexRoute component={Setting} />
            <Route path="adjustment" component={AdjustmentPanel} />
            <Route path="company" component={CompanyPanel} />
            <Route path="payment" component={PaymentPanel} />
            <Route path="position" component={PositionPanel} />
            <Route path="session" component={SessionPanel} />
            <Route path="changepwd" component={ChangePwdPanel} />
          </Route>
        </Route>
      </Route>
    </Route>
    <Route path="login" components={Login} />
    <Route path='*' component={PageNotFound} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes/index.js